<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-call :callPageData='callPage'></app-call>
        <app-footer></app-footer>
    </div>
</template>

<script>
    // import { headers } from "../config";
    import {listcallUrl, configs} from '../../config';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listCallTable} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import ListCallsComponent from "@/components/callsAndEmails/ListCallsComponent";
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VueGoodTable);
    export default {
        name: "listCall",
        mixins: [SessioMixin],
        components: {
            'app-call': ListCallsComponent,
            'app-footer': FrontFooter,
        },
        data: () => ({
                callPage: {
                    pageTitle: 'Call/Email List',
                    perPage: 25,
                    cus_id: 0,
                    is_part: 0,
                },
                loginID: 0,
                isLoggedIn: false,
            }),
        // computed: {
        //
        //         selectedRows:[]
        //
        // }
        mounted: function () {
            var initial = process.env.ROOT_API;
            initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Calls.xlsx');
            $(".removeActive").removeClass('active');
            $("#menucalls").addClass('active');
            this.showLoader();
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.isLoggedIn = true;
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/callsAndEmails/ListCall.vue